// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@guestsupply/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { orderApprovalDetailsShippingInformationStyles } from "@guestsupply/Overrides/Widgets/OrderApprovalDetails/OrderApprovalDetailsShippingInformation";
import { mergeWithCss, xScreen } from "@guestsupply/XDL/Utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

orderApprovalDetailsShippingInformationStyles.divider = {
    ...mergeWithCss(xOrderInformationStyles.address?.divider, {
        className: "divider-item",
        width: 11,
        css: css`
            &&& {
                border-top: 1px solid ${getColor("common.border")};
                margin: 8px 0 12px 0;
                padding: 0;
                min-width: 100%;
            }
        `,
    }),
};
orderApprovalDetailsShippingInformationStyles.shippingInformationCarrierGridItem = {
    ...mergeWithCss(orderApprovalDetailsShippingInformationStyles.shippingInformationCarrierGridItem, {
        css: css`
            &&& {
                margin-bottom: 5px;
                align-items: baseline;
            }
        `,
    }),
};

orderApprovalDetailsShippingInformationStyles.shippingInformationDateRequestedGridItem = {
    ...mergeWithCss(orderApprovalDetailsShippingInformationStyles.shippingInformationDateRequestedGridItem, {
        css: css`
            &&& {
                margin-bottom: 5px;
                align-items: baseline;
            }
        `,
    }),
};
orderApprovalDetailsShippingInformationStyles.shippingInformationServiceGridItem = {
    ...mergeWithCss(orderApprovalDetailsShippingInformationStyles.shippingInformationServiceGridItem, {
        css: css`
            &&& {
                margin-bottom: 5px;
                align-items: baseline;
            }
        `,
    }),
};
orderApprovalDetailsShippingInformationStyles.shippingCarrierTitle = {
    ...mergeWithCss(orderApprovalDetailsShippingInformationStyles.shippingCarrierTitle, {
        css: css`
            margin-bottom: 0;
        `,
    }),
};

orderApprovalDetailsShippingInformationStyles.shippingDateRequestedTitle = {
    ...mergeWithCss(orderApprovalDetailsShippingInformationStyles.shippingDateRequestedTitle, {
        css: css`
            margin-bottom: 0;
        `,
    }),
};
orderApprovalDetailsShippingInformationStyles.shippingServiceTitle = {
    ...mergeWithCss(orderApprovalDetailsShippingInformationStyles.shippingServiceTitle, {
        css: css`
            margin-bottom: 0;
        `,
    }),
};
orderApprovalDetailsShippingInformationStyles.shippingAddressTitle = {
    ...orderApprovalDetailsShippingInformationStyles.shippingAddressTitle,
    css: css``,
};
orderApprovalDetailsShippingInformationStyles.shippingInformationTitle = {
    ...mergeWithCss(orderApprovalDetailsShippingInformationStyles.shippingInformationTitle, {
        css: css`
            padding-top: 0;
            margin-bottom: 0;
        `,
    }),
};
orderApprovalDetailsShippingInformationStyles.shippingInformationAddressGridItem = {
    width: 12,
    css: css`
        &&& {
            width: 100%;
            max-width: 100%;
        }
    `,
};
orderApprovalDetailsShippingInformationStyles.shippingOtherInformationGridItem = {
    ...mergeWithCss(orderApprovalDetailsShippingInformationStyles.shippingOtherInformationGridItem, {
        width: 6,
        css: css`
            flex-direction: column;
            padding: 0;
        `,
    }),
};
orderApprovalDetailsShippingInformationStyles.shippingInformationGridContainer = {
    css: css``,
    offsetCss: css`
        &&& {
            width: 100%;
            max-width: 100%;
            display: block;
        }
    `,
};
orderApprovalDetailsShippingInformationStyles.informationContainer = {
    css: css`
        display: flex;
        margin: 0;
        justify-content: space-between;
        flex-direction: column;
        width: 100%;
    `,
};
orderApprovalDetailsShippingInformationStyles.displayAddressGridItem = {
    width: 12,
    css: css`
        padding: 0;
    `,
};
